import { useState } from "react";
import axios from "axios";

export const useLoanCalculator = () => {
  const [result, setResult] = useState(null);
  const [selectedResult, setSelectedResult] = useState("");

  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8001";

  const calculate = async (payload, resetSelection = false) => {
    const response = await axios.post(`${API_URL}/calculate`, payload);
    const responseData = response.data;
    setResult(responseData);

    if (resetSelection) {
      setSelectedResult(Object.keys(responseData)[0] || "");
    }

    return responseData;
  };

  return {
    result,
    setResult,
    selectedResult,
    setSelectedResult,
    calculate,
  };
};
